import React from 'react'
import { Withdrawal } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import { FormLabels, CustomTag } from 'src/components'
import styles from './WithdrawalListMovileView.module.scss'
import WithdrawalDetailsButton from '../WithdrawalActionsColumn/WithdrawalDetails/WithdrawalDetailsButton'
import WithdrawalValidateButton from '../WithdrawalActionsColumn/WithdrawalValidateButton/WithdrawalValidateButton'
import {
  getFormatedPrice,
  getTransformedDate,
  getWithdrawalCompany,
  getWithdrawalUserName,
  getWithdrawalStatusTags,
} from 'src/core/helpers'
import WithdrawalCancelButton from '../WithdrawalActionsColumn/WithdrawalCancelButton/WithdrawalCancelButton'

const WithdrawalListMovileView: React.FC<{ withdrawal: Withdrawal }> = ({ withdrawal }) => {
  const { t } = useTranslation()
  const status = getWithdrawalStatusTags(t, withdrawal)
  const currencyList = useAppSelector(currencyListSelector)
  const currencyCode = currencyList.find(c => c.id === withdrawal.currency_token_id)?.code

  const labels = {
    title: `${getWithdrawalUserName(withdrawal)} (${getWithdrawalCompany(withdrawal)})`,
    subtitle: getTransformedDate(withdrawal.created),
    thirdLabel: `${getFormatedPrice(withdrawal.amount, currencyCode)} - ${currencyCode}`
  }

  return <>
    <FormLabels {...labels} />
    <div className={styles.buttonsContent}>
      <CustomTag text={status.label} type={status.type} />
      <div className={styles.buttons}>
        <WithdrawalDetailsButton withdrawal={withdrawal} />
        <WithdrawalValidateButton withdrawal={withdrawal} />
        <WithdrawalCancelButton withdrawal={withdrawal} />
      </div>
    </div>
  </>
}

export default WithdrawalListMovileView
